import { Controller } from "@hotwired/stimulus"
import DataTable from 'datatables.net-bs5'
import * as bootstrap from 'bootstrap'

// Connects to data-controller="accounts-data-table"
export default class extends Controller {
  static targets = ['table', 'enableModal', 'enableModalTitle', 'enableModalMessage', 'enableAccountName', 'confirmEnableBtn', 'disableModal', 'disableModalTitle', 'disableModalMessage', 'disableAccountName', 'confirmDisableBtn']
  
  connect() {
    this.initializeDataTable()
    this.setupEventListeners()

    this.enableModal = new bootstrap.Modal(this.enableModalTarget)
    this.disableModal = new bootstrap.Modal(this.disableModalTarget)
  }

  initializeDataTable() {
    this.dataTable = new DataTable(this.tableTarget, {
      'language': { 'processing': '<div id="loading"><i class="bi bi-arrow-repeat spin"></i></div>' },
      'responsive': true,
      'processing': true,
      'serverSide': true,
      'searching': false,
      'bLengthChange': false,
      'lengthMenu': 10,
      'columnDefs': [
        {
          'width': '20%',
          'name': 'created_at',
          'orderable': true,
          'className': 'text-center',
          'targets': 0
        },
        {
          'width': '40%',
          'name': 'name',
          'orderable': true,
          'className': 'text-center',
          'targets': 1
        },
        {
          'width': '20%',
          'name': 'activated',
          'orderable': false,
          'className': 'text-center',
          'targets': 2,
          'render': (data, type, row) => {
            const accountId = data[3] ? data[3].split('/').pop() : null
            const accountName = row[1] || 'Unknown'
            const isActivated = data === 'Yes'
            
            if (isActivated) {
              return `<a href="#" class="me-2 icon-link" data-action="click->accounts-data-table#showDisableModal" data-disable-url="/accounts/${accountId}/toggle_activation" data-account-name="${accountName}" title="disable">
                <i class="bi bi-check-lg text-success"></i>
              </a>`
            } else {
              return `<a href="#" class="me-2 icon-link" data-action="click->accounts-data-table#showEnableModal" data-enable-url="/accounts/${accountId}/toggle_activation" data-account-name="${accountName}" title="enable">
                <i class="bi bi-x-lg text-danger"></i>
              </a>`
            }
          }
        },
        {
          'width': '20%',
          'name': 'actions',
          'orderable': false,
          'className': 'text-center',
          'targets': 3,
          'render': (data, type, row) => {
            return this.renderActions(data, row)
          }
        }
      ],
      'createdRow': (row, data, dataIndex) => {
        if (data[2] === 'No') {
          $(row).addClass('table-danger')
        }
      },
      'ajax': {
        'url': '/accounts/data_sources',
        'type': 'POST'
      }
    })
  }

  renderActions(data, row) {
    // users action
    const usersAction = `<a href="${data[1]}" class="me-2 icon-link" title="user">
      <i class="fa bi bi-people text-primary"></i>
    </a>`

    // toggle action
    const accountName = row[1] || 'Unknown'
    const isActivated = row[2] === 'Yes'
    if (isActivated) {
      const disableAction = `<a href="#" class="me-2 icon-link" data-action="click->accounts-data-table#showDisableModal" data-disable-url="${data[2]}" data-account-name="${accountName}" title="disable">
        <i class="bi bi-trash text-danger"></i>
      </a>`
      return usersAction + disableAction
    } else {
      const enableAction = `<a href="#" class="me-2 icon-link" data-action="click->accounts-data-table#showEnableModal" data-enable-url="${data[2]}" data-account-name="${accountName}" title="enable">
        <i class="bi bi-arrow-clockwise text-danger"></i>
      </a>`
      return usersAction + enableAction
    }
  }

  setupEventListeners() {
    // Setup enable/disable modals
    this.setupEnableDisableModals()
  }



  showEnableModal(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const enableUrl = event.currentTarget.dataset.enableUrl
    const accountName = event.currentTarget.dataset.accountName

    this.enableUrl = enableUrl
    this.accountName = accountName

    // Update modal content
    this.enableModalTitleTarget.textContent = 'Enable Organization'
    this.enableModalMessageTarget.textContent = 'Are you sure you want to enable this organization?'
    this.enableAccountNameTarget.textContent = accountName

    // Show enable modal
    this.enableModal.show()
  }

  showDisableModal(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const disableUrl = event.currentTarget.dataset.disableUrl
    const accountName = event.currentTarget.dataset.accountName

    this.disableUrl = disableUrl
    this.accountName = accountName

    // Update modal content
    this.disableModalTitleTarget.textContent = 'Disable Organization'
    this.disableModalMessageTarget.textContent = 'Are you sure you want to disable this organization?'
    this.disableAccountNameTarget.textContent = accountName

    // Show disable modal
    this.disableModal.show()
  }

  setupEnableDisableModals() {
    // Initialize enable/disable modal variables
    this.enableUrl = ''
    this.disableUrl = ''
    this.accountName = ''
  }

  cancelEnable() {
    this.enableModal.hide()
  }

  cancelDisable() {
    this.disableModal.hide()
  }

  confirmEnable() {
    if (!this.enableUrl) return
    
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    
    fetch(this.enableUrl, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
      } else if (data.require_totp) {
        // Show TOTP modal
        this.showTotpModal('enable')
      } else {
        alert('Enable failed')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      alert('Enable failed')
    })
    .finally(() => {
      this.cancelEnable()
      this.dataTable.ajax.reload()
    })
  }

  confirmDisable() {
    if (!this.disableUrl) return
    
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    
    fetch(this.disableUrl, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
      } else if (data.require_totp) {
        // Show TOTP modal
        this.showTotpModal('disable')
      } else {
        alert('Disable failed')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      alert('Disable failed')
    })
    .finally(() => {
      this.cancelDisable()
      this.dataTable.ajax.reload()
    })
  }

  showTotpModal(action) {
    this.currentAction = action
    
    if (action === 'toggle') {
      this.currentUrl = this.toggleUrl
    } else {
      this.currentUrl = action === 'enable' ? this.enableUrl : this.disableUrl
    }

    // Use the reusable TOTP verification modal
    const event = new CustomEvent('showTotpModal', {
      detail: {
        actionUrl: this.currentUrl,
        actionMethod: 'PATCH',
        formData: {}
      }
    })
    document.dispatchEvent(event)
  }



  disconnect() {
    if (this.dataTable) {
      this.dataTable.destroy()
    }
    if (this.enableModal) {
      this.enableModal.dispose()
    }
    if (this.disableModal) {
      this.disableModal.dispose()
    }

  }
} 